// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/patients/patients.less
// module id = 4050
// module chunks = 0